module.exports = __webpack_public_path__ + "img/ikon-ru.e4e6a095.png";